document.addEventListener("DOMContentLoaded", loadScroll);

function loadScroll() {
  const windowHeight = () => window.innerHeight;
  const productMediaVariants = document.querySelector("product-media-variants");

  if (productMediaVariants) {
    const mediaVariantsBoundingRect = () => productMediaVariants.getBoundingClientRect();
    const productMediaVariantsHeight = () => mediaVariantsBoundingRect().height;

    if (productMediaVariantsHeight() > windowHeight()) {
      const track = document.getElementById('image-scroll-track');
      const trackThumb = document.getElementById('image-scroll-thumb');

      window.addEventListener('scroll', trackUpdate);
      window.addEventListener('resize', trackUpdate);
      
      function trackUpdate () {
        if (window.screen.width >= 768){
          //page scroll calculation
          const scrollPosition = window.scrollY;
          const scrollMaximum = mediaVariantsBoundingRect().top + window.scrollY + productMediaVariantsHeight() - windowHeight();
          const percentageOfMediaContainer = Math.round(scrollPosition * 100 / scrollMaximum);

          //thumb track calculation
          const trackHeight = track.getBoundingClientRect().height;
          const thumbHeight = trackThumb.getBoundingClientRect().height;
          const trackMaximum = trackHeight - thumbHeight;

          const trackPercentageToPx = Math.round(trackMaximum * percentageOfMediaContainer / 100);
          const isScrollWithinInterval = trackMaximum > trackPercentageToPx;

          trackThumb.style.top = isScrollWithinInterval ? `${trackPercentageToPx}px` : `${trackMaximum}px`;
        }
      }
    }
  }
}